<template>
  <AppLayout>
    <div class="flex flex-col min-h-full bg-slate-50 dark:bg-slate-950 px-4 pt-6 pb-8">

      <div class="mb-6">
        <h1 class="text-xl font-bold text-slate-800 dark:text-white">Reports</h1>
        <p class="text-xs text-slate-400 mt-0.5">Select a report to view</p>
      </div>

      <div class="grid grid-cols-2 md:grid-cols-3 gap-3">
        <Link v-for="card in reportCards" :key="card.href" :href="card.href"
          class="bg-white dark:bg-slate-900 rounded-2xl border border-slate-100 dark:border-slate-800 p-5
                 flex flex-col gap-3 hover:border-indigo-200 dark:hover:border-indigo-800
                 hover:shadow-md transition-all duration-200 group">
          <div class="w-11 h-11 rounded-xl flex items-center justify-center text-2xl"
            :class="card.bg">
            {{ card.icon }}
          </div>
          <div>
            <p class="font-semibold text-sm text-slate-800 dark:text-white group-hover:text-indigo-600 dark:group-hover:text-indigo-400 transition-colors">
              {{ card.label }}
            </p>
            <p class="text-[11px] text-slate-400 mt-0.5 leading-snug">{{ card.desc }}</p>
          </div>
          <div class="flex items-center gap-1 text-indigo-500 dark:text-indigo-400 text-xs font-semibold">
            View
            <svg class="w-3.5 h-3.5 group-hover:translate-x-0.5 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
              <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5"/>
            </svg>
          </div>
        </Link>
      </div>

    </div>
  </AppLayout>
</template>

<script setup>
import { Link } from '@inertiajs/vue3'
import AppLayout from '@/layouts/AppLayout.vue'

const reportCards = [
  { href: '/reports/sales',     icon: '📈', label: 'Sales',            desc: 'Sales vs purchases, monthly breakdown', bg: 'bg-emerald-50 dark:bg-emerald-950' },
  { href: '/reports/profit',    icon: '💰', label: 'Profit & Loss',    desc: 'Gross profit, margins, product P&L',   bg: 'bg-amber-50 dark:bg-amber-950' },
  { href: '/reports/customers', icon: '👥', label: 'Customers',        desc: 'Receivable, payable, balances',         bg: 'bg-indigo-50 dark:bg-indigo-950' },
  { href: '/reports/products',  icon: '📦', label: 'Products',         desc: 'Stock value, top sellers, performance', bg: 'bg-purple-50 dark:bg-purple-950' },
  { href: '/reports/cashflow',  icon: '💳', label: 'Cash Flow',        desc: 'Payments in/out by source',             bg: 'bg-blue-50 dark:bg-blue-950' },
  { href: '/reports/invoices',  icon: '🧾', label: 'Invoices',         desc: 'Invoice counts, values, by period',     bg: 'bg-rose-50 dark:bg-rose-950' },
  { href: '/reports/wealth',    icon: '💎', label: 'Wealth Statement', desc: 'Assets, liabilities, net worth',        bg: 'bg-violet-50 dark:bg-violet-950' },
]
</script>
